export default "__VITE_ASSET__w78Fx7MV__"